import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { DownloadHelperService } from 'modules/desktop/services/download-helper.service';
import { UserdataService } from 'modules/desktop/services/userdata.service';
import { ProductEntitlementsService } from 'modules/desktop/services/product-entitlements.service';
import { UmbrellaService } from 'modules/desktop/services/umbrella.service';

declare var $: any;
@Component({
	selector: 'downloading-error-modal',
	styleUrls: ['./downloading-error-modal.style.scss'],
	templateUrl: './downloading-error-modal.template.html'
})
export class DownloadingErrorModal implements OnInit {

	public imageBasePath: string = IMAGES_BASEPATH;
	eBookName: string;

	constructor(
		private chRef: ChangeDetectorRef,
		private downloadHelperService: DownloadHelperService,
		private userdataService: UserdataService,
		private umbrellaService: UmbrellaService,
		private productEntitlementsService: ProductEntitlementsService,
	) { }


	ngOnInit() {
		$('#downloadingErrorModal').on('show.bs.modal', () => {
			let productCode = this.downloadHelperService.getDownloadingBookCode();
			if (productCode == 'pplus') {
				this.eBookName = 'Presentation Plus';
			} else {
				this.eBookName = this.getBookNamefromProductCode(productCode);
			}

			this.chRef.detectChanges();
		});
		$('#downloadingErrorModal').on('hide.bs.modal', function (e) {
			let modal: any = document.querySelector('#downloadingErrorModal');
			modal.removeAttribute("bookcode");
		})
	}

	getBookNamefromProductCode(productcode) {

		let productUmbrella;
		let user = this.userdataService.getLoggedInUser();

		if (user.role == 'teacher') {
			productUmbrella = this.umbrellaService.getUmbrellaofProduct(productcode);
		} else if (user.role == 'student') {
			productUmbrella = this.productEntitlementsService.getUmbrellaofProduct(productcode);
		}
		for (let product of productUmbrella.products) {
			if (product['dls-product'] && product['dls-product'].code == productcode) {
				return product.meta.title;
			}
		}

	}

}